import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]

  connect() {
    this.expanded = false
  }

  toggle() {
    this.expanded = !this.expanded
    this.contentTarget.classList.toggle("hidden", !this.expanded)
    this.toggleTarget.textContent = this.expanded ? "Hide quoted text" : "Show quoted text"
  }
}
